import { useT } from "@/i18n";
import { useCalendarNow } from "@/lib/use-calendar-now";
import { cn } from "@/lib/utils";
import type { TournamentSummary } from "../../../shared/tournament";
import { tournamentState } from "../../../shared/tournament-state";
import type { ScheduledGame } from "../../../shared/types";
import { Badge } from "../ui/badge";

export function TournamentStatusBadge({
  meta,
  schedule,
  compact = false,
}: {
  meta: TournamentSummary;
  schedule: readonly ScheduledGame[];
  /** The Badge's own small size below `adm`, the full size from it: for a
   *  badge on an eyebrow line (the board's head, `PageContext.meta`). */
  compact?: boolean;
}) {
  const t = useT();
  const now = useCalendarNow();
  const state = tournamentState(meta, schedule, now);
  const labels = {
    ended: "nav.ended",
    registration: "nav.registrationOpen",
    draft: "nav.draft",
    upcoming: "front.upcoming",
    inProgress: "directory.inProgress",
  } as const;
  return (
    <Badge
      variant={state === "ended" ? "outline" : "secondary"}
      className={cn(
        compact ? "adm:h-auto adm:px-3 adm:py-1.5 adm:text-sm" : "h-auto px-3 py-1.5 text-sm",
        state === "registration" && "border-brand/40 bg-brand/10 text-brand-ink dark:text-brand",
      )}
    >
      {t(labels[state])}
    </Badge>
  );
}
